// extracted by mini-css-extract-plugin
export var header = "_ss-1";
export var maskBottom = "_ss-6";
export var maskMiddle = "_ss-7";
export var maskTop = "_ss-5";
export var root = "_ss-0";
export var scrollDownButton = "_ss-3";
export var scrollDownButtonHidden = "_ss-4";
export var viewport = "_ss-2";